import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import OurStory from "@/pages/OurStory";
import Products from "@/pages/Products";
import Flavours from "@/pages/Flavours";
import Parlours from "@/pages/Parlours";
import Speciality from "@/pages/Speciality";
import Contact from "@/pages/Contact";
import BulkOrder from "@/pages/BulkOrder";
import GrowWithUs from "@/pages/GrowWithUs";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
};

function App() {
  const basename = (() => {
    const publicUrl = process.env.PUBLIC_URL || "/";
    try {
      return new URL(publicUrl).pathname || "/";
    } catch {
      return publicUrl || "/";
    }
  })();

  return (
    <div className="App">
      <BrowserRouter basename={basename}>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/our-story" element={<OurStory />} />
            <Route path="/products" element={<Products />} />
            <Route path="/flavours" element={<Flavours />} />
            <Route path="/parlours" element={<Parlours />} />
            <Route path="/speciality" element={<Speciality />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/bulk-order" element={<BulkOrder />} />
            <Route path="/grow-with-us" element={<GrowWithUs />} />
          </Routes>
        </Layout>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;

